<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    :title="title"
    @hide="onDialogHide"
    @submit="onOKClick"
  >
    <div class="row q-col-gutter-md">
      <div class="col-12">
        <hr-p class="q-mb-none">
          {{ text }}
        </hr-p>
      </div>
      <div class="col-12">
        <hr-list-select
          v-model="region"
          :options="regionOptions"
          label="Region"
          hide-bottom-space
          @update:model-value="onChangeRegion"
        />
      </div>
      <div class="col-12">
        <hr-list-select
          v-model="clinicId"
          :options="clinicsInRegion"
          label="Clinic"
          :loading="isLoadingClinics"
          :disable="region === null"
          hide-bottom-space
        />
      </div>
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="hide"
      />
      <hr-confirm-btn
        type="submit"
        :disable="disableSubmit"
        :label="okButton"
      />
    </template>
  </hr-form-dialog>
</template>
<script>
import { callFirebaseFunction } from 'boot/firebase';
import { mapState } from 'pinia';
import {
  HrConfirmBtn, HrDismissBtn, HrFormDialog, HrListSelect, HrP,
} from 'src/design-system';
import { region } from 'src/store/region';

export default {
  name: 'SelectClinic',

  components: {
    HrConfirmBtn, HrDismissBtn, HrFormDialog, HrListSelect, HrP,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    okButton: {
      type: String,
      required: true,
    },
  },

  emits: ['hide', 'ok'],

  data() {
    return {
      region: null,
      clinicId: null,

      clinicsInRegion: [],
      isLoadingClinics: false,
    };
  },

  computed: {
    ...mapState(region, ['regionOptions']),

    disableSubmit() {
      return (this.region === null) || (this.clinicId === null);
    },
  },

  methods: {

    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    }, // onDialogHide()

    async onOKClick() {
      this.$emit('ok', { region: this.region, clinicId: this.clinicId });
      this.hide();
    },

    async onChangeRegion() {
      // A clinic id only means something within its region.
      this.clinicId = null;
      this.clinicsInRegion = [];
      this.isLoadingClinics = true;
      try {
        const clinicsResult = await callFirebaseFunction('listClinics', {
          region: this.region,
        });
        this.clinicsInRegion = Object.entries(clinicsResult?.data ?? {})
          .map(([value, label]) => ({ value, label }))
          .sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
      } finally {
        this.isLoadingClinics = false;
      }
    },
  },

};
</script>
